import { useEffect, useState } from "react";
import styled from "styled-components";
import { colors } from "../../styles";
import { ReactComponent as CheckIcon } from "../../assets/icons/checkmark.svg";

const Checkbox = ({
  id,
  checked,
  ref,
  onChange,
  children,
  $size,
  ...props
}) => {
  const [state, setState] = useState(checked || false);

  useEffect(() => {
    setState(checked);
  }, [checked]);

  return (
    <Root
      role="button"
      data-testid="checkbox-root"
      onClick={() => {
        setState(!state);
        if (onChange) onChange(!state);
      }}
      className={props.rootClassName}
    >
      <div>
        <HiddenCheckbox defaultChecked={state} {...props} ref={ref} name={id} />
        <StyledCheckbox checked={state} $size={$size}>
          <Icon viewBox="0 0 24 24">
            <CheckIcon />
          </Icon>
        </StyledCheckbox>
      </div>

      {children && <Label htmlFor={id}>{children}</Label>}
    </Root>
  );
};

Checkbox.defaultProps = {
  $size: "small",
};

export default Checkbox;

const Root = styled.div`
  display: flex;
  align-items: center;
  min-height: 36px;
  padding: 1.5rem;
  cursor: pointer;

  &:hover {
    background-color: ${colors.lighterGray};
  }
`;

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  top: -9999px;
`;

const Icon = styled.svg`
  fill: white;
`;

const StyledCheckbox = styled.div`
  width: ${(props) => (props.$size === "large" ? "32px" : "16px")};
  height: ${(props) => (props.$size === "large" ? "32px" : "16px")};
  background: ${(props) => (props.checked ? colors.blue : "white")};
  border-radius: 4px;
  transition: all 150ms;
  border: ${(props) =>
    `solid 2px ${props.checked ? colors.blue : colors.gray}`};
  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
`;

const Label = styled.label`
  font-weight: ${(props) => (props.markBold ? "bold" : "normal")};
  display: block;
  margin-left: 1rem;
  cursor: pointer;
  flex-grow: 1;
`;
